import {
  Stack,
  TextField,
  MenuItem,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Alert,
} from "@mui/material";

const erpOptions = [
  "Atos 6",
  "Bling",
  "Church",
  "Conta Azul",
  "Eklesia",
  "IAS Finance",
  "Omie",
  "Prover",
  "Outros",
];

interface ERPSelectorProps {
  hasErp: "yes" | "no" | "";
  selectedErp: string;
  otherErp: string;
  error?: string;
  onHasErpChange: (value: "yes" | "no") => void;
  onSelectedErpChange: (value: string) => void;
  onOtherErpChange: (value: string) => void;
  onErrorClear: () => void;
}

const ERPSelector = ({
  hasErp,
  selectedErp,
  otherErp,
  error,
  onHasErpChange,
  onSelectedErpChange,
  onOtherErpChange,
  onErrorClear,
}: ERPSelectorProps) => {
  return (
    <FormControl component="fieldset" required>
      <FormLabel component="legend">Possui um ERP integrado?</FormLabel>
      <RadioGroup
        row
        value={hasErp}
        onChange={(e) => {
          onHasErpChange(e.target.value as "yes" | "no");
          onErrorClear();
        }}
      >
        <FormControlLabel value="yes" control={<Radio />} label="Sim" />
        <FormControlLabel value="no" control={<Radio />} label="Não" />
      </RadioGroup>
      {error && (
        <Alert severity="error" sx={{ mt: 1 }}>
          {error}
        </Alert>
      )}

      {hasErp === "yes" && (
        <Stack spacing={2} sx={{ mt: 2 }}>
          <TextField
            select
            label="ERP"
            value={selectedErp}
            onChange={(e) => {
              onSelectedErpChange(e.target.value);
              onOtherErpChange("");
              onErrorClear();
            }}
            size="small"
            fullWidth
            error={!!error}
          >
            {erpOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>

          {selectedErp === "Outros" && (
            <TextField
              label="Nome do ERP"
              value={otherErp}
              onChange={(e) => {
                onOtherErpChange(e.target.value);
                onErrorClear();
              }}
              size="small"
              fullWidth
              error={!!error}
            />
          )}
        </Stack>
      )}
    </FormControl>
  );
};

export default ERPSelector;
